import React from "react";
import { AuthContext } from "../Providers/auth";


export default function useAuth() {
  const authContext = React.useContext(AuthContext);
  console.log('AuthContext:', authContext); // Should not be null
  return authContext;
}